// © Microsoft Corporation. All rights reserved.

import {
    DialogArticleCard as BaseDialogArticleCard,
    DialogArticleCardHandledProps as BaseDialogArticleCardHandledProps,
    DialogArticleCardProps as BaseDialogArticleCardProps,
    DialogArticleCardManagedClasses,
    DialogArticleCardUnhandledProps
} from "./DialogArticleCard";
import manageJss, { ManagedJSSProps } from "@microsoft/fast-jss-manager-react";

import { DesignSystem } from "@microsoft/fast-components-styles-msft";
import { DialogArticleCardClassNameContract } from "./DialogArticleCard.classnames";
import { DialogArticleCardStyles } from "./DialogArticleCard.styles";
import { Subtract } from "utility-types";

/*
 * The type returned by manageJss type is very complicated so we'll let the
 * compiler infer the type instead of re-declaring just for the package export
 */
const DialogArticleCard = manageJss(DialogArticleCardStyles)(BaseDialogArticleCard);
type DialogArticleCard = InstanceType<typeof DialogArticleCard>;

// Create a valid JSS managed interface that doesn't require managed classes which are provided by the manageJSS HOC
type DialogArticleCardHandledProps = Subtract<BaseDialogArticleCardHandledProps, DialogArticleCardManagedClasses>;

// Create type for manageJSS HOC styled instance we are exporting
type DialogArticleCardProps = ManagedJSSProps<
    BaseDialogArticleCardProps,
    DialogArticleCardClassNameContract,
    DesignSystem
>;

export {
    DialogArticleCard,
    DialogArticleCardProps,
    DialogArticleCardHandledProps,
    DialogArticleCardUnhandledProps,
    DialogArticleCardManagedClasses,
    DialogArticleCardClassNameContract
};